<mat-card class="content-card ng-star-inserted" >
  <mat-card-header>
    <mat-card-title>
      <h5>Partner API Keys</h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="list-item" fxLayout="row" *ngFor="let apiKey of apiKeys ">
      <label fxFlex="10">
        <ng-container *ngIf="apiKey.isEnabled">
          <mat-icon style="color: forestgreen">done</mat-icon>
        </ng-container>
        <ng-container *ngIf="!apiKey.isEnabled">
          <mat-icon style="color: orangered">block</mat-icon>
        </ng-container>
      </label>
      <label fxFlex="25">
        <div><small>Created: {{apiKey.createdAt|date:'dd.MM.yyyy'}}</small></div>
        <div>{{ apiKey.apiKeyId }}-*****</div>
        <div><small>Comment: {{apiKey.comment}}</small></div>
        <div *ngIf="!apiKey.isEnabled"><small style="color: orangered">Disabled</small></div>
        <div *ngIf="apiKey.apiKeyType === partnerApiKeyType.PseudoAtm"><small style="border-radius: 5px; background-color: orangered">ATM</small></div>
      </label>
      <label fxFlex="45">
        <ng-container *ngIf="apiKey.permissions">
          <ul style="margin-top: 0">
            <li *ngFor="let permission of apiKey.permissions.split(',')">
              {{ permission }}
            </li>
          </ul>
        </ng-container>
      </label>
      <label fxFlex="20">
        <ng-container  *ngIf="apiKey.isEnabled">
          <a (click)="disableApiKey(apiKey.apiKeyId)"><mat-icon>block</mat-icon></a>
        </ng-container>
        <ng-container  *ngIf="!apiKey.isEnabled">
          <a (click)="enableApiKey(apiKey.apiKeyId)"><mat-icon>done</mat-icon></a>
        </ng-container>
        <a (click)="deleteApiKey(apiKey.apiKeyId)"><mat-icon>clear</mat-icon></a>

        <a (click)="editApiKey(apiKey.apiKeyId)"><mat-icon>edit</mat-icon></a>

      </label>
    </div>
  </mat-card-content>
  <mat-card-actions align="end">
    <a
      mat-raised-button
      color="primary"
      (click)="addApiKey()">
      Create Api Key
    </a>
  </mat-card-actions>
</mat-card>
